import { InnerBox } from "@/components/elements/InnerBox";
import { MatchInfoItem } from "@/features/match/components/match-info/MatchInfoItem";
import { TMatchInfo } from "@/features/match/types/MatchInfo";
import { CollapsibleSectionHeader, useCollapsible } from "@/features/talent/components/talent-common/CollapsibleSectionHeader";
import { divider } from "@/theme/colors";
import { FCC } from "@/types/common";
import { convertNumberToZipCode } from "@/utils/input";
import { Collapse, Grid } from "@mui/material";

type TMatchLocationInfoProps = {
  defaultValues: Partial<TMatchInfo>;
};

export const MatchLocationInfo: FCC<TMatchLocationInfoProps> = ({ defaultValues }) => {
  const { expanded, toggle } = useCollapsible();

  return (
    <InnerBox showDivider={false} padding={3} borderColor={divider.high}>
      <CollapsibleSectionHeader title="所在地" expanded={expanded} onToggle={toggle} />

      <Collapse in={expanded}>
        <Grid mt={2} container columnSpacing={3} rowSpacing={1}>
          <Grid item xs={12} sm={6} md={4}>
            <MatchInfoItem label="郵便番号" value={defaultValues.zipCode && convertNumberToZipCode(defaultValues.zipCode)} />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <MatchInfoItem label="都道府県" value={defaultValues.prefecture} />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <MatchInfoItem label="市区町村" value={defaultValues.city} />
          </Grid>

          <Grid item xs={12}>
            <MatchInfoItem label="町名丁目番地号等" value={defaultValues.address} isShowDivider={false} />
          </Grid>
        </Grid>
      </Collapse>
    </InnerBox>
  );
};
